import { TypographyH4 } from '@talentmesh/ui/components/typography';

interface StatusCounterProps {
    status: string;
    count: number;
}

function BigStatusCounter({ status, count }: StatusCounterProps) {
    return (
        <div className="bg-muted flex h-full min-h-36 flex-col items-center justify-between rounded-xl pt-3 pb-5">
            <div className="flex h-full flex-col items-center justify-between gap-1" data-cy={`${status}Counter`}>
                <TypographyH4 className="text-foreground text-center" data-cy={`${status}Status`}>
                    {status}
                </TypographyH4>
                <span className="text-foreground text-3xl font-bold tracking-tight" data-cy={`${status}Count`}>
                    {count}
                </span>
            </div>
        </div>
    );
}

export default BigStatusCounter;
